import { ProductAddonsResponse } from 'models/Product';
import httpApi from '../api/httpApi';
import useSWR from 'swr';

const BASE_URL = '/api/v1/products';

const useProductAddonsSWR = (productId: string) => {
    const fetch = (query): Promise<ProductAddonsResponse> => {
        return httpApi
            .get<ProductAddonsResponse>(query)
            .then((res) => {
                return res.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        `${BASE_URL}/${productId}/additional/all`,
        fetch,
        {
            dedupingInterval: 600000,
            errorRetryCount: 3,
        }
    );

    return {
        productAddons: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useProductAddonsSWR;
